/**
 * This is used to detect if the initial video in a feed.
 * When initialVideoId is set It creates a 2nd feed with the initial video ID.
 * If the initialVideoId not set or found it in the 1st feed, use the 1st feed.
 * If the initialVideoId is not found in the 1st feed, it uses the 2nd feed.
 * For safety, if 2nd feed is null, still use the 1st feed.
 */
export async function createFeedWithInitVideoDetect({ config, createFeedApi, params, }) {
    return new Promise((resolve, reject) => {
        const paramsWithInitialVideoId = {
            ...params,
            firstVideoId: config.initialVideoId,
        };
        let firstResponse = null;
        let secondResponse = null;
        let promiseHandledCount = 0;
        createFeedApi(params)
            .then((feed) => {
            firstResponse = feed;
            promiseHandledCount++;
            if (!config.initialVideoId ||
                existInFeed(feed, config.initialVideoId)) {
                return resolve(feed);
            }
            if (secondResponse || promiseHandledCount > 1) {
                return resolve(secondResponse);
            }
        })
            .catch((err) => reject(err));
        const initialVideoPromise = config.initialVideoId
            ? createFeedApi(paramsWithInitialVideoId)
            : Promise.resolve(null);
        initialVideoPromise
            .then((feedWithInitVideoId) => {
            secondResponse = feedWithInitVideoId;
            promiseHandledCount++;
            if (!firstResponse) {
                return;
            }
            if (!config.initialVideoId ||
                existInFeed(firstResponse, config.initialVideoId)) {
                return resolve(firstResponse);
            }
            else if (existInFeed(secondResponse, config.initialVideoId)) {
                return resolve(secondResponse);
            }
            return resolve(firstResponse);
        })
            .catch((err) => reject(err));
    });
}
/**
 * check if a video exists in the feed.
 * @param feed - The feed to check.
 * @param videoId - The video ID to check for.
 * @returns true if the video exists in the feed, false otherwise.
 */
function existInFeed(feed, videoId) {
    return !!feed?.feed_items?.find((item) => item.video?.encoded_id === videoId);
}
